"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringifyNullProperties = void 0;
function stringifyNullProperties(input) {
  var convertProperties = function convertProperties(obj) {
    var res = {};
    Object.keys(obj).reduce(function (acc, key) {
      if (obj[key] === null) {
        acc[key] = "null";
      } else if (typeof obj[key] === "object") {
        acc[key] = convertProperties(obj[key]);
      } else {
        acc[key] = obj[key];
      }
      return acc;
    }, res);
    return res;
  };
  return convertProperties(input);
}
exports.stringifyNullProperties = stringifyNullProperties;